import React from "react";
import { Mail, Phone, Printer, MapPin } from "lucide-react";
import { COMPANY, NAV_LINKS } from "../data/mock";
import { Logo } from "./Illustrations";

const Footer = () => {
  const handleNav = (e, href) => {
    e.preventDefault();
    document.querySelector(href)?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <footer className="bg-[#2c2a3d] text-white/70">
      <div className="aaa-container py-16">
        <div className="grid md:grid-cols-3 gap-10">
          <div>
            <div className="flex items-center gap-3 mb-4">
              <Logo className="w-9 h-9" />
              <span className="font-display text-white text-lg" style={{ fontWeight: 500 }}>
                AAA Computers &amp; Tech.
              </span>
            </div>
            <p className="text-sm leading-relaxed max-w-xs text-white/60">
              Empowering small to medium businesses with workstations, servers,
              networking and AI-ready infrastructure.
            </p>
          </div>

          <div>
            <h4 className="font-display text-white font-semibold mb-4">Explore</h4>
            <ul className="space-y-2 text-sm">
              {NAV_LINKS.map((l) => (
                <li key={l.href}>
                  <a
                    href={l.href}
                    onClick={(e) => handleNav(e, l.href)}
                    className="text-white/60 hover:text-white transition-colors duration-200"
                  >
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-display text-white font-semibold mb-4">Get in touch</h4>
            <ul className="space-y-3 text-sm">
              <li className="flex items-start gap-3">
                <MapPin size={17} className="mt-0.5 text-[#ef8296] shrink-0" />
                <span className="text-white/60">{COMPANY.address.full}</span>
              </li>
              <li className="flex items-center gap-3">
                <Mail size={17} className="text-[#ef8296] shrink-0" />
                <a href={`mailto:${COMPANY.email}`} className="text-white/60 hover:text-white transition-colors">
                  {COMPANY.email}
                </a>
              </li>
              <li className="flex items-center gap-3">
                <Phone size={17} className="text-[#ef8296] shrink-0" />
                <a href={`tel:${COMPANY.phoneHref}`} className="text-white/60 hover:text-white transition-colors">
                  {COMPANY.phone}
                </a>
              </li>
              <li className="flex items-center gap-3">
                <Printer size={17} className="text-[#ef8296] shrink-0" />
                <span className="text-white/60">Fax: {COMPANY.fax}</span>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="aaa-container py-6 text-xs text-white/45 leading-relaxed">
          ©{COMPANY.year} {COMPANY.shortName} All rights reserved. All product names,
          products and companies referred to herein are trademarks or registered
          trademarks of their respective companies or mark holders.
        </div>
      </div>
    </footer>
  );
};

export default Footer;
